import { MantineThemeOverride } from "@mantine/core";

const mantineTheme: MantineThemeOverride = {
  colors: {
    primary: [
      "#ffe3e8",
      "#ffcbd6",
      "#ffa0b5",
      "#ff6b8f",
      "#fc376c",
      "#eb1e5f",
      "#c50b4a",
      "#a50c45",
      "#8d0e41",
      "#4f0220",
    ],

    secondary: [
      "#fff8eb",
      "#ffecc6",
      "#ffd788",
      "#ffbc4a",
      "#ffa21f",
      "#f97e07",
      "#dd5902",
      "#b73b06",
      "#942c0c",
      "#7a250d",
    ],

    tertiary: [
      "#fff1f3",
      "#ffe3e6",
      "#ffccd4",
      "#ffa2b1",
      "#fe6e89",
      "#f93a63",
      "#e6184e",
      "#c20e41",
      "#a90f40",
      "#8b103b",
    ],
  },
  primaryColor: "primary",
};

export default mantineTheme;
